/**
 *校牌保修期管理
*/
import request from '@/utils/request';
import { getToken } from '@/utils/auth';
import ENVIRONMENT from '@/utils/environment';

// 分页查询社区列表
export function school_plate_repair_pagelist(options) {
  return request({
    url: `/op/school-plate-repair/`,
    method: 'get',
    params: options
  });
}

// 添加
export function school_plate_repair_add(data) {
  return request({
    url: `/op/school-plate-repair/`,
    method: 'post',
    data
  });
}
// 删除
export function school_plate_repair_del(id) {
  return request({
    url: `/op/school-plate-repair/${id}`,
    method: 'DELETE'
  });
}

// -----------通过学校获取社区信息
export function schoolCommunityList(schoolCode) {
  return request({
    url: `/op/school-plate-repair/school-community/${schoolCode}`,
    method: 'get'
  });
}
// -----------通过学校获取核销批次
export function provDatesList(schoolCode) {
  return request({
    url: `/op/school-plate-repair/school-batch/${schoolCode}`,
    method: 'get'
  });
}
// -----------修改核销日期
export function provDatesEdit(options) {
  return request({
    url: `/op/school-plate-repair/${options.id}`,
    method: 'put',
    data: { provDate: options.provDate }
  });
}
// -----------获取保修期列表数据详情Details
export function school_plate_repair_details(id) {
  return request({
    url: `/op/school-plate-repair/${id}`,
    method: 'get'
  });
}

// -----------获取保修期列表数据详情Details
export function school_plate_repair_config_list(options) {
  return request({
    url: `/op/school-plate-repair/config/`,
    method: 'get',
    params: options
  });
}
// -----------获取保修期列表数据详情Details
export function school_plate_repair_config_edit(options, id) {
  return request({
    url: `/op/school-plate-repair/config/${id}`,
    method: 'put',
    data: options
  });
}
// -----------批量导入
export function improtExcel(schoolCode) {
  return `${ENVIRONMENT.BASE_API}/op/school-plate-repair/import/${schoolCode}`;
}
// -----------模板
export function templateExcel(stype) {
  return `${ENVIRONMENT.BASE_API}/op/school-plate-repair/export/?token=${getToken()}&stype=${stype}`;
}
/**
 *批量导出
 */
export function exportSimExcel(schoolCode, options) {
  let url = '';
  url = `${ENVIRONMENT.BASE_API}/op/school-plate-repair/export/${schoolCode}?`;
  for (var key in options) {
    url += `${key}=${options[key]}&`;
  }
  url = url.substring(0, url.lastIndexOf('&'));
  return url + `&token=${getToken()}`;
}
